<template>
  <div class="ailmBanner">
    <div class="center">
      <div class="banner-overlay1">
        <span class="title">AI教育</span>
        <p>为了帮助合作伙伴以更低成本和更高效率加速大模型 AI 应用的落地，MoPaaS 构建了一个 AI 加速闭环生态体系，为合作伙伴的数字化转型、智能化升级和创新融合直接赋能。特别是通过 MoPaaS 的大模型 AI 应用型人才培训计划，精准满足不同企业和机构学员从大模型 AI 的基础认知、深入理解到实际应用的多层次需求。
        </p>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'AiEduBanner',
  }
</script>

<style>
  .ailmBanner {
    width: 100%;
    height: 20.833vw;
    margin-top: 72px;
    overflow-y: hidden;
    background-image: url("../assets/images/aiedubanner.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .ailmBanner .center {
    width: auto !important;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding-left: 13.54vw;
  }

  .ailmBanner .banner-overlay1 {
    padding-top:  5.76vw;
    color: #FFFFFF;
    text-align: left;
  }


  .ailmBanner .banner-overlay1 .title {
    width: auto;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 25px;
    text-align: left;
    font-style: normal;
  }

  .ailmBanner .banner-overlay1 p {
    width: 42vw;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    opacity: 0.7;
    margin-top: 21px;
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/AiEduBanner.vue